// extracted by mini-css-extract-plugin
export var border = "_c-8";
export var brand = "_c-t";
export var button = "_c-l";
export var center = "_c-a";
export var centered = "_c-6";
export var closeButton = "_c-c";
export var disabledWrapper = "_c-m";
export var error = "_c-p";
export var extraLarge = "_c-4";
export var extraSmall = "_c-1";
export var fill = "_c-i";
export var footer = "_c-h";
export var footerAction = "_c-j";
export var footerButtons = "_c-k";
export var header = "_c-7";
export var headerWithClose = "_c-d";
export var icon = "_c-o";
export var info = "_c-s";
export var inline = "_c-9";
export var large = "_c-3";
export var main = "_c-e";
export var modal = "_c-0";
export var nearFull = "_c-5";
export var neutral = "_c-u";
export var noPadding = "_c-g";
export var none = "_c-v";
export var scrollable = "_c-f";
export var small = "_c-2";
export var success = "_c-r";
export var tight = "_c-n";
export var titleIcon = "_c-b";
export var warn = "_c-q";